import { twMerge } from 'tailwind-merge'

type SeparatorProps = {
  className?: string
} & ((React.ComponentPropsWithoutRef<'span'>))

export function Separator({ className }: SeparatorProps) {
  className = twMerge(
    'relative border-l min-h-5',
    className,
  )

  return (
    <span className={className} />
  )
}

